/**
 * Token Manager Utility
 * Manages JWT token storage in localStorage
 */

const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

export const tokenManager = {
  /**
   * Get the access token from localStorage
   * @returns {string|null} The access token or null if not found
   */
  getAccessToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  /**
   * Get the refresh token from localStorage
   * @returns {string|null} The refresh token or null if not found
   */
  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  /**
   * Store both access and refresh tokens
   * @param {string} accessToken - The JWT access token
   * @param {string} refreshToken - The JWT refresh token
   */
  setTokens(accessToken, refreshToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  /**
   * Clear all tokens from localStorage
   */
  clearTokens() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  /**
   * Check if user has a valid access token
   * @returns {boolean} True if access token exists
   */
  hasAccessToken() {
    return !!this.getAccessToken();
  }
};
